import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./header.css";
import AOS from "aos";
import "aos/dist/aos.css";
import logo from '../../img/CodeQlik_logo.png'

function Header() {
    // Fade Animation on scroll
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <>
            <div className="navbarcolor sticky-top">
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid">
                        {/* Logo */}
                        <NavLink className="navbar-brand" to="/">
                            <img
                                src={logo}
                                alt="Logo"
                                style={{ height: "30px" }}
                                className="d-inline-block align-text-top"
                            />
                        </NavLink>

                        {/* Navbar toggler */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* Navigation Links */}
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav mx-auto">
                                <li className="nav-item m-2">
                                    <NavLink
                                        to="/"
                                        className={({ isActive }) =>
                                            `nav-link ${isActive ? "active" : ""}`
                                        }
                                    >
                                        Home
                                    </NavLink>
                                </li>
                                <li className="nav-item m-2">
                                    <NavLink
                                        to="/about"
                                        className={({ isActive }) =>
                                            `nav-link ${isActive ? "active" : ""}`
                                        }
                                    >
                                        About
                                    </NavLink>
                                </li>
                                <li className="nav-item m-2">
                                    <NavLink
                                        to="/servicedetail"
                                        className={({ isActive }) =>
                                            `nav-link ${isActive ? "active" : ""}`
                                        }
                                    >
                                        Services
                                    </NavLink>
                                </li>
                                <li className="nav-item m-2">
                                    <NavLink
                                        to="/projects"
                                        className={({ isActive }) =>
                                            `nav-link ${isActive ? "active" : ""}`
                                        }
                                    >
                                        Projects
                                    </NavLink>
                                </li>
                                <li className="nav-item m-2">
                                    <NavLink
                                        to="/blog"
                                        className={({ isActive }) =>
                                            `nav-link ${isActive ? "active" : ""}`
                                        }
                                    >
                                        Blogs
                                    </NavLink>
                                </li>
                                <li className="nav-item m-2">
                                    <NavLink
                                        to="/staffaugmentation"
                                        className={({ isActive }) =>
                                            `nav-link ${isActive ? "active" : ""}`
                                        }
                                    >
                                        Staff Augmentation
                                    </NavLink>
                                </li>
                                <li className="nav-item m-2">
                                    <NavLink
                                        to="/careers"
                                        className={({ isActive }) =>
                                            `nav-link ${isActive ? "active" : ""}`
                                        }
                                    >
                                        Careers
                                    </NavLink>
                                </li>
                                <li className="nav-item m-2">
                                    <NavLink
                                        to="/contact"
                                        className={({ isActive }) =>
                                            `nav-link ${isActive ? "active" : ""}`
                                        }
                                    >
                                        Contact Us
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </>
    );
}

export default Header;
